import { API } from '../api';

// Функция для регистрации пользователя
export async function registerUser(username, email, password) {
  try {
    const response = await fetch(API.register, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to register');
    }

    // Сохраняем токен в локальном хранилище, если он возвращается
    localStorage.setItem('accessToken', data.jwt);
    return data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
}

// Функция для входа пользователя
export async function loginUser(identifier, password) {
  try {
    const response = await fetch(API.login, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ identifier, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to login');
    }

    // Сохраняем токен в локальном хранилище
    localStorage.setItem('accessToken', data.jwt);
    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
}

// Функция для получения токена из локального хранилища
export function getAccessToken() {
  return localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
}

// Пример функции для выполнения запроса с использованием токена
export async function fetchWithToken(url, options = {}) {
  const token = getAccessToken();

  if (!token) {
    throw new Error('No access token available');
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 401) {
    throw new Error('Unauthorized');
  }

  return response.json();
}

// Функция для получения профиля пользователя
export async function getProfile() {
  try {
    const response = await fetchWithToken(API.profile, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Profile fetching error:', error);
    throw error;
  }
}

export async function getUserTables() {
  try {
    const response = await fetchWithToken(`${API.BASE_URL}/editable-tables`, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Tables fetching error:', error);
    throw error;
  }
}

export async function getUserViewableTables() {
  try {
    const response = await fetchWithToken(`${API.BASE_URL}/viewable-tables`, {
      method: 'GET',
    });
    // Исключаем таблицу с переводами
    const filteredTables = response.filter(table => table.modelName !== 'perevod');
    return filteredTables;
  } catch (error) {
    console.error('Tables fetching error:', error);
    throw error;
  }
}

